import {Component, HostListener, OnDestroy, OnInit} from '@angular/core';
import {Title} from "@angular/platform-browser";

import {PermissionService} from "./services";
import {Store} from "@ngxs/store";
import {LocalStorageService} from "./services";
import {AppState, ChangeLanguage, ChangeProductView} from "./state";
import {environment} from "../environments/environment";
import {SubscriptionHandlerComponent} from "./components/shared";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: [
        './app.component.css'
    ],
    standalone: false
})
export class AppComponent extends SubscriptionHandlerComponent implements OnInit, OnDestroy {
    screenHeight: number;

    constructor(public permissionService: PermissionService,
                private titleService: Title,
                private store: Store,
                private localStorageService: LocalStorageService) {
        super();

        if (environment.production)
            this.titleService.setTitle("AUMA - RIS");
        else
            this.titleService.setTitle("TEST - AUMA RIS");

        this.getScreenSize();
    }

    @HostListener('window:resize', ['$event'])
    getScreenSize() {
        this.screenHeight = window.innerHeight;
    }

    async ngOnInit(): Promise<void> {
        await this.permissionService.init();

        let view = this.localStorageService.getItem('selectedProductView');

        if (view)
            this.store.dispatch(new ChangeProductView(view));
        else
            this.store.dispatch(new ChangeProductView("cards"));

        let storedLangCode = this.localStorageService.getItem('selectedLanguage');

        this.subscribeTo(this.store.select(AppState.languages), languages => {
            if (languages.length > 0) {
                this.subscribeTo(this.permissionService.accessRights$, x => {
                    if (x) {
                        this.subscribeTo(x.userRight_RIS2_ACCESS_DEVELOPER_TEXTS$, access => {
                            let storedLang = languages.find(x => x.languageCode === storedLangCode);
                            if (access) {
                                if (storedLang)
                                    this.store.dispatch(new ChangeLanguage(storedLang));
                                else {
                                    const defaultLangDEV = languages.find(x => x.id === 1);
                                    this.store.dispatch(new ChangeLanguage(defaultLangDEV!));
                                }
                            } else {
                                const defaultLangEN = languages.find(x => x.id === 3);
                                if (storedLang) {
                                    if (storedLang.id !== 1)
                                        this.store.dispatch(new ChangeLanguage(storedLang));
                                    else {
                                        this.store.dispatch(new ChangeLanguage(defaultLangEN!));
                                    }
                                } else {
                                    this.store.dispatch(new ChangeLanguage(defaultLangEN!));
                                }
                            }
                        });
                    }
                });
            }
        });
    }

    override ngOnDestroy(): void {
        this.permissionService.onDestroy();
        super.ngOnDestroy();
    }

    protected readonly environment = environment;
}
